import { render } from "./Tagsview.vue?vue&type=template&id=08954e10"
import script from "./Tagsview.vue?vue&type=script&lang=js"
export * from "./Tagsview.vue?vue&type=script&lang=js"
script.render = render

export default script